/* Function that checks if a story is resolved, when editing in the storyblok editor, 
the story is not resolved for a split second at times, so we need to check if the story is resolved or not. */

export const isUnresolved = <T>(value: T | string): value is string =>
  typeof value === "string";
